/* eslint-disable @typescript-eslint/no-unnecessary-qualifier */
import { Enum, Obj, Str } from '@livecontrol/core-utils';

export interface Slide {
  id?: Slide.ID;
  slide_type?: string;
  file_type?: string;
  file_name: string;
  url: string;
  duration?: number;
  size?: number;
  secondary_index?: number;
}

export namespace Slide {
  export type ID = number | string;
  export type Like = ID | Slide;

  export const toId = (slide?: Like): ID | undefined =>
    Str.normalize(Obj.isObject<Slide>(slide) ? slide.id : slide);

  export enum Type {
    Intro = 1,
    Outro = 2,
    Other = 3
  }

  export namespace Type {
    export const normalize = (value: unknown): Type | undefined =>
      Str.normalize(value)?.includes('intro')
        ? Type.Intro
        : Str.normalize(value)?.includes('outro')
        ? Type.Outro
        : Enum.normalize(Type, value);

    export const stringValues = new Map<Type, string>([
      [Type.Intro, 'intro'],
      [Type.Outro, 'outro'],
      [Type.Other, 'other']
    ]);

    export const toString = (service: Type): string => stringValues.get(service)!;
  }
}
